<template>
    <div class="market-parkingRecord-ccr-index">
      <Search :renderData="renderData" :formData="form" :labelWidth="100" @onSearch="onSearch">
      </Search>
      <div class="fun-btn-box">
      </div>
      <Table
        :tableThData="tableThData"
        :tableTrData="tableTrData"
        :loading="loading"
        :limit="limit"
        :total="total"
        :offset="offset"
        v-on:handleSizeChange="handleSizeChange"
        v-on:handleCurrentChange="handleCurrentChange"
      > 
        <template #name="{ row }">{{ row.name }}</template>
        <template #mallName="{ row }">{{ row.mallName }}</template>
        <template #phone="{ row, scope }">
          <span :key="tableKey">{{ row.phone_show || row.phone }}</span>
          <auth-button auth="user:phone:read">
            <el-button v-if="row.phone" class="look-phone-btn"  type="text" @click="onLookPhone(row, scope.$index)">
              {{ row.phone_show ? '隐藏' : '查看' }}
            </el-button>
          </auth-button>
        </template>
        <template #discount="{ row }">{{ row.discount || '---' }}</template>
        <template #orderNo="{ row }">{{ row.orderNo ?row.orderNo : '---'}}</template>
        <template #usedTime="{ row }">{{ row.usedTime ? $moment(row.usedTime).format('YYYY/MM/DD HH:mm:ss') : '---' }}</template>
        <template #platform="{ row }">{{ row.platform}}</template>
      </Table>
    </div>
  </template>
  
  <script>
  import AuthButton from '@/components/AuthButton'
  import tableList from '@/mixins/tableList'
  import aes from '@/common/aes.js'
  import { api_getParkingCouponRecordList} from '@/api/market'
  import { api_getUserPhone } from '@/api/common'
  import Search from "@/components/Search/index";
  import Table from "@/components/Table/index";
  export default {
    name: "mParkingCouponRecordIndex",
    mixins: [ tableList ],
    components: {
      AuthButton,
      Search,
      Table,
    },
    data() {
      return {
        renderData: [
          {
            label: "停车券名称",
            placeholder: "请输入停车券名称",
            type: "input",
            key: "name",
          },
          {
            label: "会员手机号",
            placeholder: "请输入会员手机号",
            type: "input",
            key: "phone",
          },
          {
            label: "商场名称",
            placeholder: "请选择商场名称",
            type: "mall",
            key: "mallIds",
          },
       
        ],
        form: {},
        tableKey: false,
        exportLoading: false,
        tableThData: [
          { prop: "name", label: "停车券名称", minWidth: "180", },
          { prop: "mallName", label: "商场名称", minWidth: "180", },
          { prop: "phone", label: "会员手机号", minWidth: "160", },
          { prop: "discount", label: "抵扣优惠", minWidth: "160", },
          { prop: "orderNo", label: "交易订单号", minWidth: "160", },
          { prop: "usedTime", label: "核销时间", minWidth: "200", },
          { prop: "platform", label: "来源", minWidth: "160", },
        ],
  
      };
    },
    created () {
    },
    methods: {
      // 获取表格列表数据
      async getList () {
        this.loading = true
        let params = {
          ...this.form,
          offset: this.offset,
          limit: this.limit,
        }
        this.$router.push({query: params})
        const data = await api_getParkingCouponRecordList(params)
        console.log('data: ', data);
        this.tableTrData = data.list || []
        this.total = data.count
        this.loading = false
      },
  
      // 点击查看手机号
       async onLookPhone(row, index) {
          if (row.phone_show) {
            delete this.tableTrData[index].phone_show
          } else {
            const {phone} = await api_getUserPhone({id: row.userId})
            this.tableTrData[index].phone_show = aes.decrypt(phone)
          }
          this.tableKey = !this.tableKey
        }
    },
    watch: {
    },
    computed: {},
  };
  </script>
  <style lang="scss" scoped>
  .market-parkingRecord-ccr-index {
    width: 100%;
    box-sizing: border-box;
  
    .fun-btn-box {
      margin-top: 20px;
    }
  
    .look-phone-btn {
      font-size: 10px;
      color: #3775FF;
      margin-left: 5px;
    }
  
    .del {
      color: #F74A4A;
    }
    .status{
      width: 6px;
      height: 6px;
      display: inline-block;
      border-radius: 50%;
      vertical-align: middle;
    }
    .dot-success{
      background: #05c8af;
    }
  
    .dot-clear {
      background: #F74A4A;
    }
  
    .dot-ing {
      background: #3775FF;
    }
  
    .dot-new {
      background: #ccc;
    }
  }
  </style>
  